import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	HStack,
	Input,
	Select,
	Spacer,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
} from '@chakra-ui/react';
import { options } from './data';

import { TicketsAccordion } from './ticketsAccordion';

export const Tickets = ({ admin, wakeTickets, setWakeTickets, setUserID }) => {
	const [loading, setLoading] = useState(true);
	const [tickets, setTickets] = useState([]);
	const [users, setUsers] = useState([]);

	const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
	const [newAssignee, setNewAssignee] = useState(0);
	const [customer, setCustomer] = useState(0);
	const [title, setTitle] = useState('');
	const [content, setContent] = useState('');
	const [dueDate, setDueDate] = useState('');

	const chooseAssignee = e => {
		setNewAssignee(e.target.value);
		setIsSubmitDisabled(false);
	};

	const submitNewTicket = () =>
		axios({
			method: 'post',
			url: `/tickets`,
			data: {
				reporter: admin,
				assignee: newAssignee,
				title,
				content,
				customer,
				dueDate,
			},
			...options(),
		})
			.then(() => {
				setIsSubmitDisabled(true);
				setCustomer(0);
				setNewAssignee(0);
				setTitle('');
				setContent('');
				setDueDate('');
				setWakeTickets(new Date().getTime());
			})
			.catch(console.log);

	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get('/tickets', options());
			if (!active) {
				return;
			}
			setTickets(res.data.tickets);
			setUsers(res.data.users);
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [wakeTickets]);

	if (loading) return <p>Loading...</p>;

	const workers = users.filter(({ customer }) => !customer);
	const customers = users.filter(({ customer }) => customer);

	const toMe = tickets.filter(
		({ assignee_id, closed }) => assignee_id === admin && !closed
	);
	const byMe = tickets.filter(
		({ reporter_id, closed }) => reporter_id === admin && !closed
	);
	const active = tickets.filter(({ closed }) => !closed);
	const done = tickets.filter(({ closed }) => closed);

	return (
		<HStack align="top">
			<Box
				w="50%"
				borderRadius="md"
				border="1px"
				borderColor="gray.200"
				p={4}
				mr={4}
			>
				<Heading pb={6} fontSize={'xl'}>
					New ticket
				</Heading>
				<Box>
					<FormControl mb={4}>
						<FormLabel>Title</FormLabel>
						<Input
							type="text"
							placeholder="Enter the ticket title here"
							value={title}
							onChange={e => setTitle(e.target.value)}
						/>
					</FormControl>
					<Box mb={4}>
						<Select
							placeholder="Choose customer"
							onChange={e => setCustomer(e.target.value)}
							value={customer}
						>
							{customers.map(({ id, name }) => (
								<option value={id}>
									{name}
								</option>
							))}
						</Select>
					</Box>
					<FormControl mb={4}>
						<FormLabel>Content</FormLabel>
						<Input
							type="text"
							placeholder="Enter the ticket content here"
							value={content}
							onChange={e => setContent(e.target.value)}
						/>
					</FormControl>
				</Box>
				<HStack pb={6}>
					<Box>
						<Select placeholder="Choose an assignee" onChange={chooseAssignee} value={newAssignee}>
							{workers.map(({ id, name }) => (
								<option value={id}>
									{name}
								</option>
							))}
						</Select>
					</Box>
					<Spacer />
					<Box>
						{' '}
						<Input
							type="date"
							value={dueDate}
							onChange={e => setDueDate(e.target.value)}
						/>
					</Box>
					<Spacer />
					<Button
						colorScheme="blue"
						isDisabled={isSubmitDisabled}
						onClick={submitNewTicket}
					>
						Create ticket
					</Button>
				</HStack>
			</Box>
			<Box w="50%" borderRadius="md" border="1px" borderColor="gray.200" p={4}>
				<Heading pb={6} fontSize={'xl'}>
					Tickets
				</Heading>
				<Tabs variant="soft-rounded" colorScheme="blue">
					<TabList textAlign="center">
						<Tab>{`To Me (${toMe.length})`}</Tab>
						<Tab>{`By Me (${byMe.length})`}</Tab>
						<Tab>{`Active (${active.length})`}</Tab>
						<Tab>{`Done (${done.length})`}</Tab>
					</TabList>
					<TabPanels>
						<TabPanel>
							<TicketsAccordion
								{...{ tickets: toMe, workers, admin, setWakeTickets, setUserID }}
							/>
						</TabPanel>
						<TabPanel>
							<TicketsAccordion
								{...{ tickets: byMe, workers, admin, setWakeTickets, setUserID }}
							/>
						</TabPanel>
						<TabPanel>
							<TicketsAccordion
								{...{ tickets: active, workers, admin, setWakeTickets, setUserID }}
							/>
						</TabPanel>
						<TabPanel>
							<TicketsAccordion
								{...{ tickets: done, workers, admin, setWakeTickets, setUserID }}
							/>
						</TabPanel>
					</TabPanels>
				</Tabs>
			</Box>
		</HStack>
	);
};
